import { Box, makeStyles, MenuItem, Select, TypographyProps } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';
import React from 'react';

import { LenderIconAvatar } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';

import { APP_ROLES } from '../../../../config/config';
import { useRoles } from '../../../../hooks/useRoles';
import { Font, TITLE_COLOR_ID } from '../Font';
import { Text } from '../Text';

interface LenderSelectFilterProps {
  selectedLenders: LenderName[];
  setSelectedLenders: (e) => void;
  style?: React.CSSProperties;
  placeholderColor?: TypographyProps['color'] | typeof TITLE_COLOR_ID;
}

const ALLOWED_ROLES_FOR_COMPONENT = [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN];

export const LenderSelectFilter = ({
  selectedLenders,
  setSelectedLenders,
  style,
  placeholderColor,
}: LenderSelectFilterProps) => {
  const { roleExistsInProfile } = useRoles();

  const isAllowedByRole = roleExistsInProfile(ALLOWED_ROLES_FOR_COMPONENT);

  if (!isAllowedByRole) return <></>;

  const useStyles = makeStyles({
    root: {
      '& .MuiInputBase-input': {
        textOverflow: 'ellipsis',
      },
    },
  });

  const classes = useStyles();

  return (
    <Select
      multiple
      displayEmpty
      className={classes.root}
      value={selectedLenders}
      onChange={(e) => setSelectedLenders(e.target.value as LenderName)}
      renderValue={(selected: LenderName[]) => (
        <>
          {selected.length === 0 ? (
            <Font color={placeholderColor ?? undefined}>
              <Text tId={'LENDER'} />
            </Font>
          ) : selected.length > 4 ? (
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
              {selected.slice(0, 4).map((lender) => (
                <div key={lender}>
                  <LenderIconAvatar size={'small'} transparent lenderName={lender} />
                </div>
              ))}
              <Font variant="body2" color="textSecondary">
                {` +${selected.length - 4}`}
              </Font>
            </Box>
          ) : (
            <Box display={'flex'} flexDirection={'row'}>
              {selected.map((lender) => (
                <>
                  <LenderIconAvatar size={'small'} transparent lenderName={lender} />
                  <Box pr={'3px'} />
                </>
              ))}
            </Box>
          )}
        </>
      )}
      style={{ minWidth: '150px', maxHeight: '40px', marginTop: '8px', ...style }}
    >
      {Object.values(LenderName).map((lender) => (
        <MenuItem value={lender}>
          <LenderIconAvatar transparent lenderName={lender} />
          <Box ml={1} />
          <Font variant={'body1'} color={'textSecondary'}>
            <Text tId={lender} />
          </Font>
        </MenuItem>
      ))}
    </Select>
  );
};
